import {
  LineageBrowserDataCatalogProvider,
  VizPortalDataCatalogProviderProps,
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { VirtualConnectionTableLineageSubplaceRouter, VirtualConnectionTableLineageSubplaceRouterProps } from './VirtualConnectionTableLineageSubplace';

export type EmbeddableVirtualConnectionTableSubplaceProps = VizPortalDataCatalogProviderProps & VirtualConnectionTableLineageSubplaceRouterProps;

export function EmbeddableVirtualConnectionTableSubplaceWithoutRouter(props: EmbeddableVirtualConnectionTableSubplaceProps): JSX.Element {
  return (
    <LineageBrowserDataCatalogProvider {...props}>
      <VirtualConnectionTableLineageSubplaceRouter vizportalUrlId={props.vizportalUrlId} />
    </LineageBrowserDataCatalogProvider>
  );
}
